import { render, staticRenderFns } from "./SyncForm.vue?vue&type=template&id=59a9d22d"
import script from "./SyncForm.vue?vue&type=script&lang=js"
export * from "./SyncForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports